import { r as registerInstance, h, H as Host } from './index-16dc7dde.js';
import { t as tryParse } from './parsers-e38ff6a5.js';
import { B as Brand } from './types-66e6568b.js';

const apcPesComparisonPdfCss = ":host{display:block}";

let ApcPesComparisonPdf = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  componentWillLoad() {
    var _a, _b, _c;
    this.comparatorLabels = (_a = tryParse(this._comparatorLabels)) !== null && _a !== void 0 ? _a : this.comparatorLabels;
    this.comparatorCharacteristics = (_b = tryParse(this._comparatorCharacteristics)) !== null && _b !== void 0 ? _b : this.comparatorCharacteristics;
    this.comparatorPriceInfo = (_c = tryParse(this._comparatorPriceInfo)) !== null && _c !== void 0 ? _c : this.comparatorPriceInfo;
  }
  render() {
    return (h(Host, null, h("pes-comparison-pdf", { comparatorLabels: this.comparatorLabels, comparatorCharacteristics: this.comparatorCharacteristics, comparatorPriceInfo: this.comparatorPriceInfo, brand: Brand.apc })));
  }
};
ApcPesComparisonPdf.style = apcPesComparisonPdfCss;

export { ApcPesComparisonPdf as apc_pes_comparison_pdf };
